import React from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';

import Homes from './Pages/Home/Homes';
import BlogDetails from './Blogs copy/BlogDetails';
import BlogList from './Blogs copy/BlogList';
import { blogs } from './Blogs copy/BlogData';
import Login from './Member Login And Register/Login';
import Register from './Member Login And Register/Register';
import ProtectedRoute from './Dashbord/ProtectedRoute';
import Dashboard from './Dashbord/Dashbord';
import MemberPortal from './UserDashbord/MemberPortal';
import AllNews from './Pages/AllNews/AllNews';
import News from './Pages/News';
import NewsDetails from './Pages/NewsDetails';
import Footer from './components/Footer';
import Header from './components/Header';
import Navbar from './components/Navbar';
import Hom2 from './Pages/Home';
import SearchResults from './components/SearchResults'; // adjust path
import CategoryPage from './components/CategoryPage';

function AppLayout() {
  const location = useLocation();
  const isDashboard = location.pathname === '/dashboard';

  return (
    <>
      {!isDashboard && <Navbar />}
      {!isDashboard && <Header />}

      <Routes>
        <Route path="/" element={<Hom2 />} />
        <Route path="/home" element={<Homes />} />
        <Route path="/login" element={<Login />} />
        {/* <Route path="/register" element={<Register />} /> */}
        {/* <Route path="/memberportal" element={<MemberPortal />} /> */}
        {/* <Route path="/rotary-events" element={<AllNews />} /> */}
        {/* <Route path="/hom2" element={<Hom2 />} /> */}
        <Route path="/news" element={<News />} />
        <Route path="/news/:id" element={<NewsDetails />} />
        <Route path="/blog/:title" element={<BlogDetails />} />
         <Route path="/search/:keyword" element={<SearchResults />} />
        <Route path="/blogs" element={<BlogList blogs={blogs} count={100000000000} />} />
        <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
         <Route path="/category/:slug" element={<CategoryPage />} />

      </Routes>

      {!isDashboard && <News />}
      {!isDashboard && <Footer />}
    </>
  );
}

function App() {
  return (
    <Router>
      <AppLayout />
    </Router>
  );
}

export default App;
